export default {
    mounted(el, binding) {
        if (binding.value) {
            document.body.style.overflow = 'hidden';
        }
    },
    update(el, binding) {
        // 当指令绑定的值发生变化时调用
        if (binding.value) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    },
    unmounted() {
        // 指令与元素解绑时恢复滚动
        document.body.style.overflow = '';
    }
};
